import React, { FC } from 'react';

import styles from './TextButton.module.scss';
import { HippoComponentProps } from '../index';
import classNames from 'classnames';
import Icon from '../Icon/Icon';

export interface Props extends HippoComponentProps {
  text: string;
  size: 'small' | 'regular' | 'large' | 'extra-large';
  type: 'accent' | 'primary' | 'primary-inverse' | 'location' | 'negative';
  disabled?: boolean;
  leadingIcon?: string;
  trailingIcon?: string;
  onClick?: () => void;
}

const TextButton: FC<Props> = ({
  text,
  size,
  type,
  dataQA,
  className,
  disabled = false,
  leadingIcon,
  trailingIcon,
  onClick,
}) => {
  return (
    <button
      data-qa={dataQA}
      className={classNames(
        styles.container,
        className,
        styles[size],
        styles[type],
        {
          [styles.disabled]: disabled,
        }
      )}
      onClick={onClick}
    >
      {leadingIcon && (
        <div className={styles.iconFrameLeading}>
          <Icon dataQA="leading-icon" name={leadingIcon} size={24} />
        </div>
      )}
      {text}
      {trailingIcon && (
        <div className={styles.iconFrameTrailing}>
          <Icon dataQA="trailing-icon" name={trailingIcon} size={24} />
        </div>
      )}
    </button>
  );
};

export default TextButton;
